import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { INetflixForgotAccountPayload, INetflixForgotAccountResponse } from '../../../entity/interface/iEntitlements';
import { CSRFTokenRequest } from '../../../entity';

export interface INetflixForgotAccountUseCase {
    execute(
        payload: INetflixForgotAccountPayload,
        csrfToken?: CSRFTokenRequest
    ): Promise<INetflixForgotAccountResponse>;
}

export class NetflixForgotAccountUseCase implements INetflixForgotAccountUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get netflixForgotAccountRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: INetflixForgotAccountPayload,
        csrfToken?: CSRFTokenRequest
    ): Promise<INetflixForgotAccountResponse> {
        return this.netflixForgotAccountRepository.netflixForgotAccount(payload, csrfToken);
    }
}
